<template>
    <div class="header header_centered">
        <div class="header__content">
            <a :href="$whitelabel.website_url" :title="$whitelabel.name">
              <img class="header__logo" :src="$whitelabel.resources.logo" :alt="$whitelabel.name" />
            </a>
            <h2>
                <slot name="title">{{ title }}</slot>
            </h2>
            <div class="ot-label">
                <slot name="subtitle">{{ subtitle }}</slot>
            </div>
            <div class="extra-info">
                <slot name="extra">{{ extra }}</slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeaderCentered extends Vue {

    @Prop() title!: string;

    @Prop() subtitle!: string;

    @Prop() extra!: string;

    @Prop() logo!: string;

}
</script>

<style lang="scss" scoped>
.header_centered {
    text-align: center;

    &::v-deep .extra-info {
        font-weight: 500;
        font-size: 16px;
    }
}

.header {
    &__content {
        padding: var(--ot-spacing-2xl) var(--ot-spacing-2xl);
    }

    &__logo {
        width: 10em;
        margin-top: var(--ot-spacing-default);
        margin-bottom: var(--ot-spacing-2xl);
    }
}

</style>
